<template>
  <div class="flex flex-col bg-white border rounded p-5 h-full">
    <div class="flex-grow">
      <div class="font-bold text-2xl">{{ infoCard.title }}</div>
      <div class="my-5 flex items-center relative">
        <div
          v-if="(index === 0 || index === 1 || index === 2) && free_teacher_account"
          class="absolute top-2 left-2.5 px-7 py-2 bg-white text-green-700 z-10 border-2 border-green-700 rounded font-semibold"
        >
          Upgrade </br>Required
        </div>
        <img
          v-if="index === 0 || index === 1 || index === 2"
          :src="infoCard.image"
          class="w-36 h-20"
          :class="[free_teacher_account ? 'opacity-50' : '']"
        />
        <img v-else :src="infoCard.image" class="h-20 w-20" />
        <div :class="[index === 2 ? 'ml-7' : 'ml-5']">
          {{ infoCard.description }}
        </div>
      </div>
    </div>
    <button
      class="w-full py-2 px-4 bg-primary hover:bg-primary-dark text-white uppercase rounded relative disabled:opacity-50 "
      :disabled="(index === 0 || index === 1 || index === 2) && free_teacher_account"
      @click="$emit('goTo', index)"
    >
      <span class="font-bold text-2xl mr-1">{{ infoCard.button }}</span>
      <span
        v-if="index === 3 || index === 4 || index === 5"
        class="absolute top-2"
      >
        <i class="fas fa-external-link-alt text-xs" />
      </span>
    </button>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {};
    },
    props: {
      infoCard: {
        type: Object,
        default() {
          return {};
        },
      },
      index: {
        type: Number,
        default() {
          return 0;
        },
      },
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourses']),
      free_teacher_account() {
        return !this.getProfile.is_paid || !this.getProfile.school.school_id;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// supportCard.vue?f727e41c